<h2> Aanmelden als {{ role === 'teacher' ? 'leerkracht' : 'schoolbeheerder' }} </h2>

<form
  [formGroup]="form"
  (ngSubmit)="submit('basic')"
  data-cy="form-teacher-login"
  class="[ stack stack-space-s ] [ relative w-full max-w-xl ]"
  >
  <dcr-animated-kai
    #kai
    src="assets/rive/kai_state_machine.riv"
    autoplay
    class="kai"
    track-lookat
    react-to-click
  ></dcr-animated-kai>

  @switch (mode) {
    @case ('login') {
      <dcr-text-field
        label="E-mailadres / Gebruikersnaam"
        data-cy="input-login-form-email"
        formControlName="email"
        [@wiggle]="state === 'error'"
      ></dcr-text-field>
      <dcr-text-field
        label="Wachtwoord"
        type="password"
        formControlName="password"
        data-cy="input-login-form-password"
        [@wiggle]="state === 'error'"
      ></dcr-text-field>
    }
    @case ('forgot-password') {
      <dcr-text-field
        label="E-mailadres"
        formControlName="email"
        [@wiggle]="state === 'error'"
        data-cy="input-request-password-form-email"
      ></dcr-text-field>
    }
  }

  @if (state === 'error') {
    <div
      class="[ border border-error corner-s ][ error-container ][ p-i-s p-b-xs ]"
      data-cy="login-error"
      >
      {{ uiState[mode].error }}
    </div>
  }

  <div class="[ flex flex-wrap gap-2xs ]">
    <dcr-filled-button
      type="submit"
      [label]="uiState[mode].cta"
      [disabled]="state !== 'processing' && (form.invalid || state === 'success' || state === 'error')"
      data-cy="btn-login-form-sign-in"
    ></dcr-filled-button>
    <dcr-inline-button
      (click)="setMode(mode === 'login' ? 'forgot-password' : 'login')"
      [label]="uiState[mode].toggleMode"
      data-cy="btn-login-form-login-mode"
    ></dcr-inline-button>
  </div>

  <div
    class="[ stack stack-space-xs ][ body-medium p-s ][ surface-container border border-stroke-variant ][ corner-m ]"
    data-cy="login-no-access"
    >
    @if (role === 'teacher') {
      <span>Vraag jouw inloggegevens aan de schoolbeheerder.</span>
    }
    <span>Heeft jouw school nog geen toegang?</span>
    <span>
      Mail de schoolgegevens naar
      <a href="mailto:kabas@diekeure.be" data-cy="link-no-access-mail-to" class="text-primary">kabas&#64;diekeure.be</a>
    </span>
  </div>
</form>
